<template>
  <v-breadcrumbs class="ag-breadcrumbs" :items="items">
    <template #divider>
      <AGIcon icon="md:keyboard_arrow_right" size="16px" />
    </template>

    <template #item="{ item }">
      <v-breadcrumbs-item
        active-class="ag-breadcrumbs__item"
        :class="{ 'ag-breadcrumbs__item--current-route': item.active }"
        :disabled="item.disabled"
        :to="{ name: item.name, params: item.params }"
      >
        <AGButtonIcon
          v-if="item.title === 'Home'"
          class="ag-breadcrumbs__item-home"
          icon="mdi-home-outline"
          size="md"
        />

        <template v-else>
          {{ item.title }}
        </template>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import AGButtonIcon from '@/components/common/AGButtonIcon.vue';
import AGIcon from '@/components/common/AGIcon.vue';

export default {
  components: {
    AGIcon,
    AGButtonIcon,
  },

  props: {
    items: {
      default: [
        {
          title: 'Home',
          disabled: false,
          name: 'RouteHome',
        },
        {
          title: 'Página 1',
          disabled: true,
        },
        {
          title: 'Página 2',
          disabled: false,
          active: true,
        },
      ],
    },
  },

  data: () => ({
    mockItems: [
      {
        title: 'Home',
        disabled: false,
        name: 'RouteHome',
      },
      {
        title: 'Página 1',
        disabled: true,
      },
      {
        title: 'Página 2',
        disabled: false,
        active: true,
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
.ag-breadcrumbs {
  padding: 0 !important;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  ::v-deep(.v-icon) {
    margin-inline: 0;
  }

  .ag-breadcrumbs__item {
    padding: 0;
    font-size: $font-size-xxs;
  }

  ::v-deep(.v-breadcrumbs-divider) {
    padding: 0;
    color: rgba(0, 0, 0, 0.54);
  }

  .ag-breadcrumbs__item--current-route {
    font-weight: $font-weight-bold;
  }

  ::v-deep(.v-breadcrumbs-item--disabled) {
    opacity: 1;

    a {
      cursor: default !important;
      color: $neutral-color-high-light !important;
    }
  }
}
</style>
